import { userErrorFragment } from './fragmentGeneral.gql';
import cartFragment from './fragmentCart.gql';

const cartCreate = (
	`mutation ($input: CartInput!) {
		cartCreate(input: $input) {
			userErrors ${userErrorFragment}
			cart ${cartFragment}
		}
	}`
);

export default cartCreate;
